import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/invitations/useInvitationQueryKeys.ts
var t = e("booking-invitations", {
	list: (e) => ["list", e],
	myList: (e) => ["my-list", e],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as invitationQueryKeys };
